/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

// this is autogenerated file, see scripts/version-update.js
export const PACKAGE_VERSION = '0.70.0';
export const PACKAGE_NAME = '@opentelemetry/instrumentation-pg';
